import { useQuery } from "@tanstack/react-query";
import { useDataPointsApi } from "../../../../../hooks";
import { DataPointDisplay } from "../../../../Emissions/DataPointDisplay";
import { useMapData } from "../../../hooks/mapDataAndFilters";
import { SidebarSection } from "../../../ui/SidebarItems";

export const DataPointDetailsTab = () => {
    const { selectedContext } = useMapData("mainMap");
    const apiClient = useDataPointsApi();

    // Emission information
    const dataPointQuery = useQuery({
        queryKey: ["dataPointDetails", selectedContext.dataPointId],
        queryFn: async () => {
            return await apiClient.dataPointsRetrieve({
                id: selectedContext.dataPointId,
            });
        },
        enabled: !!selectedContext.dataPointId,
    });

    return (
        <div className="w-[400px] h-full bg-white">
            <SidebarSection
                title="Properties"
                loading={dataPointQuery.isLoading}
            >
                <DataPointDisplay dataPoint={dataPointQuery.data} />
            </SidebarSection>
        </div>
    );
};
